import { getRouteApi } from '@tanstack/react-router';

export const offersRouteApi = getRouteApi('/auth/merchant/menuLayout/assortment/');

export const categoriesRouteApi = getRouteApi('/auth/merchant/menuLayout/assortment/categories');

export const assortmentProductRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/assortment/products/$assortmentProductId',
);

export const assortmentProductRedirectRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/assortment/products/$countryCode/$productId',
);

export const assortmentSetsRouteApi = getRouteApi('/auth/merchant/menuLayout/assortment/sets');

export const assortmentSetDetailsRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/assortment/sets/$setId',
);
